import {
  RugbyLeagueEventStatusId,
  RugbyLeagueIncidentId,
  RugbyLeagueResultId,
} from '@collector/sportsapi-client-legacy'

import { PitchPenaltyOverlayConfig } from '../../../configuration'

export const pitchPenaltyOverlayConfig: PitchPenaltyOverlayConfig<
  RugbyLeagueEventStatusId,
  RugbyLeagueResultId,
  RugbyLeagueIncidentId
> = {
  penaltyStatusId: RugbyLeagueEventStatusId.Penalties,
  penaltyResultId: RugbyLeagueResultId.Penalty,
  scoredPenaltyIncidentId: RugbyLeagueIncidentId.PenaltyKickGoal,
  missedPenaltyIncidentId: RugbyLeagueIncidentId.PenaltyKickMissed,
}
